import styled from 'styled-components';

const ContentLayout = styled.div`
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => height || 'auto'};
  padding-top: ${({ paddingTop }) => paddingTop || 24}px;
  padding-left: ${({ padding }) => padding || 24}px;
  padding-right: ${({ padding }) => padding || 24}px;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || 24}px;
  margin-top: ${({ marginTop }) => marginTop || 24}px;
  border: ${({ border }) => border || '1px solid #e7eef0'};
  border-radius: 8px;
  position: relative;
`;

export { ContentLayout };
